import { render, staticRenderFns } from "./Contype.vue?vue&type=template&id=3f097620"
import script from "./Contype.vue?vue&type=script&lang=js"
export * from "./Contype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports